// role.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';

export interface Role {
  id: number;
  role_name: string;
  role_description: string;
  client_id: number;
  privilege_names: string[];
  modified_on: string;
  modified_by: number;
  created_on: string;
  created_by: number;
  status?: boolean;
}

export interface UpdateRoleRequest {
  role_name: string;
  role_description: string;
  privilege_names: string[];
  client_id: number | null;
  status: boolean;
}


export interface RoleResponse {
  count: number;
  results: Role[];
}

export interface RoleRequest {
  client_id: number | null;
}

export interface CreateRoleRequest {
  role_name: string;
  role_description: string;
  privilege_names: string[];
  client_id: number | null;
  status: boolean;
    created_by?: number; // Add this optional field

}

export interface GroupedPrivileges {
  [moduleId: string]: string[];
}


@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private apiUrl = `${env.apiUrl}/acl/v1/role/list`;
  private createRoleUrl = `${env.apiUrl}/acl/v1/role`;
  private groupedPrivilegesUrl =`${env.apiUrl}/acl/v1/master-privileges/grouped`;
  constructor(private http: HttpClient) { }

  getRoles(body: any = {}): Observable<RoleResponse> {
    return this.http.post<RoleResponse>(this.apiUrl, body);
  }

  getRolesExport(body: any = {}): Observable<Blob> {
    return this.http.post(this.apiUrl, body, {
      responseType: 'blob'
    });
  }

  createRole(roleData: CreateRoleRequest): Observable<any> {
    return this.http.post(this.createRoleUrl, roleData);
  }

  getGroupedPrivileges(): Observable<GroupedPrivileges> {
    return this.http.get<GroupedPrivileges>(this.groupedPrivilegesUrl);
  }

    updateRole(roleId: number, roleData: UpdateRoleRequest): Observable<any> {
    const updateUrl = `${env.apiUrl}/acl/v1/role/${roleId}`;
    return this.http.put(updateUrl, roleData);
  }
}